import { render, staticRenderFns } from "./Shema.vue?vue&type=template&id=7b553ec4&"
import script from "./Shema.vue?vue&type=script&lang=js&"
export * from "./Shema.vue?vue&type=script&lang=js&"
import style0 from "./Shema.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports